import {
  extractPuniBrokerFromPeople,
  extractRetailBrokerFromPeople,
  extractSurplusBrokerFromPeople,
  exrtractNthUnderwriterFromPeople,
  extractBrokerFromPeople,
  extractAssistantFromPeople,
  extractProducerBrokerFromPeople,
  extractWholesaleBrokerFromPeople,
  extractPersonFromPeople,
} from "domain/people";
import { resolvePeople } from "domain/peopleResolver";

export const selectResolvedPeople = (state) => resolvePeople(state);

export const selectBroker = (state) => {
  const people = resolvePeople(state);
  return extractBrokerFromPeople(people);
};

export const selectPuniBroker = (state) => {
  const people = resolvePeople(state);
  return extractPuniBrokerFromPeople(people);
};

export const selectRetailBroker = (state) => {
  const people = resolvePeople(state);
  return extractRetailBrokerFromPeople(people);
};

export const selectSurplusBroker = (state) => {
  const people = resolvePeople(state);
  return extractSurplusBrokerFromPeople(people);
};

export const selectProducerBroker = (state) => {
  const people = resolvePeople(state);
  return extractProducerBrokerFromPeople(people);
};

export const selectWholesaleBroker = (state) => {
  const people = resolvePeople(state);
  return extractWholesaleBrokerFromPeople(people);
};

export const selectNthUnderwriter = (n) => (state) => {
  const people = resolvePeople(state);
  return exrtractNthUnderwriterFromPeople(n)(people);
};

export const selectPreferredUnderwriter = (state) =>
  selectNthUnderwriter(0)(state);

export const selectSecondaryUnderwriter = (state) =>
  selectNthUnderwriter(1)(state);

export const selectUnderwriterAssistant = (state) =>
  selectNthUnderwriter(2)(state);

export const selectAssistant = (state) => {
  const people = resolvePeople(state);
  return extractAssistantFromPeople(people);
};

export const selectPersonByRole = (role) => (state) => {
  const people = resolvePeople(state);
  return extractPersonFromPeople(role)(people);
};
